module.exports = __webpack_public_path__ + "static/media/bg_trial_resumption_under_30.41860cb2.webp";